import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_PATH } from "utils/env";
import { useToast, Box, Spinner, Text, VStack } from "@chakra-ui/react";

const MicrosoftCallback = () => {
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("code");

    if (code) {
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/auth/microsoft`, { code })
        .then((res: any) => {
          if (res?.data?.status === "success" && res?.data?.token) {
            const { token, expiresIn } = res.data;

            // Save token
            sessionStorage.setItem("auth-token", token);

            // Save expiry timestamp (in milliseconds)
            const expiryTimestamp = Date.now() + expiresIn * 1000;
            sessionStorage.setItem(
              "auth-token-expiry",
              expiryTimestamp.toString()
            );

            toast({
              title: "Login successful",
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top-right",
            });

            window.location.href = BASE_PATH;
          } else {
            toast({
              title: "Login failed",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "top-left",
            });
            localStorage.removeItem("auth-token");
            setTimeout(() => {
              window.location.href = BASE_PATH;
            }, 2000);
          }
        })
        .catch((err: any) => {
          toast({
            title:
              err?.response?.data?.message || err?.message || "Login failed",
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top-right",
          });
          localStorage.removeItem("auth-token");
          setTimeout(() => {
            window.location.href = BASE_PATH;
          }, 2000);
        });
    }
  }, [searchParams, navigate]);

  return (
    <Box
      w="100vw"
      h="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
    >
      <VStack spacing={4}>
        <Spinner size="xl" thickness="4px" color="blue.500" />
        <Text fontSize="lg" fontWeight="medium">
          Logging you in, please wait...
        </Text>
      </VStack>
    </Box>
  );
};

export default MicrosoftCallback;